import { SubOrdenDetalleRutas, GetResponseBody, GetHeaderRequest } from './RutasConfig';

export const Modificar_Detalle_Orden_Articulo_Validado_Request = async (pToken, pEmpresa_Id, pSucursal_Id, pOrden_Id, pCallCenter_Id, pArticulo_Id) => {
    const data = { Emp_Id: pEmpresa_Id, Suc_Id: pSucursal_Id, Orden_Id: pOrden_Id, CC_Id: pCallCenter_Id, Articulo_Id: pArticulo_Id };
    const result = await fetch(SubOrdenDetalleRutas.Modificar_Detalle_Orden_Articulo_Validado, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(data)
    });
    return await GetResponseBody(result);
};